"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBulkActionMenu = void 0;
const react_1 = require("react");
function useBulkActionMenu() {
    const [opened, setOpened] = react_1.useState(false);
    const openMenu = react_1.useCallback(() => {
        setOpened(true);
    }, []);
    const closeMenu = react_1.useCallback(() => {
        setOpened(false);
    }, []);
    return {
        opened,
        openMenu,
        closeMenu,
    };
}
exports.useBulkActionMenu = useBulkActionMenu;
//# sourceMappingURL=bulk-action-hook.js.map